document.addEventListener("DOMContentLoaded", () => {
    // --- ADD THIS FOR ORANGE CHECKBOX BORDERS & MOBILE LAYOUT FIXES ---
    const customStyle = document.createElement('style');
    customStyle.innerHTML = `
        /* 1. Perfect Square Checkboxes */
        input[type="checkbox"] {
            -webkit-appearance: none;
            appearance: none;
            background-color: #fff;
            border: 2px solid #fc765bff; 
            border-radius: 3px;
            width: 18px;
            height: 18px;
            min-width: 18px; 
            min-height: 18px; 
            flex-shrink: 0; 
            box-sizing: border-box;
            display: inline-grid;
            place-content: center;
            cursor: pointer;
            margin: 0;
        }
        input[type="checkbox"]::before {
            content: "";
            width: 10px;
            height: 10px;
            transform: scale(0);
            transition: 120ms transform ease-in-out;
            box-shadow: inset 1em 1em white;
            transform-origin: center;
            clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 16%, 80% 0%, 43% 62%);
        }
        input[type="checkbox"]:checked {
            background-color: #fc765bff; 
        }
        input[type="checkbox"]:checked::before {
            transform: scale(1); 
        }

        /* 2. Phase 6 Mobile Layout Fixes */
        .extra-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            flex-wrap: nowrap !important; 
            gap: 10px;
        }
        .extra-price {
            white-space: nowrap !important; 
            flex-shrink: 0 !important; 
        }
        .premium-toggle {
            display: flex !important;
            align-items: center !important;
            gap: 16px !important; 
            margin-top: 24px !important; 
            flex-wrap: nowrap !important; 
        }
        .premium-toggle .toggle-box {
            white-space: nowrap !important; 
            font-size: clamp(12px, 3.5vw, 16px) !important; 
            padding-right: 8px !important; 
        }

        /* 3. Phase 7 Bundle Layout Fixes (The Overlap Badge Fix) */
        .tier-box {
            position: relative !important;
            margin-bottom: 28px !important; 
        }
        .bottom-overlap-badge {
            position: absolute;
            bottom: 0;
            left: 50%;
            transform: translate(-50%, 50%);
            background-color: #22c55e;
            color: white;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: bold;
            
            /* 👇 NEW: Prevents bleeding outside the box 👇 */
            max-width: 90%; 
            width: max-content; 
            text-align: center;
            line-height: 1.1; 
            
            text-transform: uppercase;
            letter-spacing: 0.5px;
            z-index: 10; 
            box-shadow: 0 2px 4px rgba(0,0,0,0.15); 
        }
        
        /* Mobile-Specific Tweaks */
        @media (max-width: 768px) {
            .tier-header-container {
                gap: 6px !important; /* Slightly reduces gap so boxes have more width */
            }
            .bottom-overlap-badge {
                /* 👇 Aggressively shrinks text and padding on phones 👇 */
                font-size: clamp(8px, 2.5vw, 10px); 
                padding: 3px 6px;
                letter-spacing: 0px; 
                white-space: normal; /* Allows "GRATIS" and "VERSAND" to stack if needed */
                border-radius: 12px; 
            }
        }
    `;
    document.head.appendChild(customStyle);

    // --- AUTO-OPEN CART DRAWER ---
    if (window.location.search.includes('cart=open')) {
        // 1. Clean the URL instantly
        const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
        window.history.replaceState({path:newUrl}, '', newUrl);

        const openAmpCart = () => {
            // METHOD 1: The newest AMP JS API 
            if (window.AMP_API && typeof window.AMP_API.OPEN_CART === 'function') {
                window.AMP_API.OPEN_CART();
                return true;
            }
            // METHOD 2: The legacy AMP API
            if (typeof window.SLIDECART_OPEN === 'function') {
                window.SLIDECART_OPEN();
                return true;
            }
            // METHOD 3: Alternate AMP API
            if (window.SlideCart && typeof window.SlideCart.open === 'function') {
                window.SlideCart.open();
                return true;
            }
            return false;
        };

        // Poll every 100ms until AMP fully mounts on the page
        let tries = 0;
        const timer = setInterval(() => {
            tries++;
            
            // If the API fires, clear the interval
            if (openAmpCart()) {
                clearInterval(timer);
            } 
            // Give up after 5 seconds (50 tries * 100ms)
            else if (tries > 50) { 
                clearInterval(timer);
                
                // LAST RESORT FALLBACK: Only click the native icon if AMP failed to load
                const toggle = document.querySelector('#cart-icon-bubble, .header__icon--cart, a[href^="/cart"]');
                if (toggle) {
                    toggle.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));
                }
            }
        }, 100);
    }
    const root = document.getElementById("book-funnel-root");
    if (!root) return; // Stop if not on the funnel page
    document.body.classList.add('funnel-active'); // Only add the class IF on the funnel

    const n8nWebhook = window.bookFunnelConfig ? window.bookFunnelConfig.webhookUrl : "";
    // --- Step Indicator Helper ---
    function getStepIndicatorHTML(currentStep) {
        const totalSteps = 6;
        let dotsHtml = '';
        for(let i = 1; i <= totalSteps; i++) {
            let status = '';
            if (i === currentStep) status = 'active';
            else if (i < currentStep) status = 'completed';
            
            dotsHtml += `<div class="step-dot ${status}"></div>`;
            if (i < totalSteps) {
                 dotsHtml += `<div class="step-line ${i < currentStep ? 'completed' : ''}"></div>`;
            }
        }
        return `
            <div class="step-indicator-wrapper">
                <div class="step-indicator-track">
                    ${dotsHtml}
                </div>
                <div class="step-indicator-text">Schritt ${currentStep} von ${totalSteps}</div>
            </div>
        `;
    }

    // --- HELPER: Bulletproof Scroll for iOS ---
    function forceScrollToTop() {
        // 1. Immediate scroll (catches most devices instantly)
        window.scrollTo(0, 0);
        document.documentElement.scrollTop = 0; 
        
        // 2. The Android Catcher: Fires right after the browser finishes drawing the new HTML
        setTimeout(() => {
            window.scrollTo(0, 0);
            document.documentElement.scrollTop = 0; 
            document.body.scrollTop = 0; 
        }, 50); 
    }
    
    // --- Dynamic Theme & ID Logic ---
    const urlParams = new URLSearchParams(window.location.search);
    const themeName = urlParams.get('theme'); 
    const dynamicBaseId = urlParams.get('baseId'); 
    
    const themeTitleEl = document.getElementById('dynamic-theme-title');
    if (themeTitleEl) {
        themeTitleEl.innerText = themeName ? `Thema: ${themeName}` : 'Dein Buch wird personalisiert...';
    }

    // --- Funnel Header Close Logic ---
    const closeFunnelBtn = document.getElementById('funnel-close-btn');
    if (closeFunnelBtn) {
        closeFunnelBtn.addEventListener('click', () => {
            if (window.history.length > 1) {
                window.history.back();
            } else {
                window.location.href = '/';
            }
        });
    }
    
    // --- Dynamic Notification Bar Logic ---
    const notificationEl = document.querySelector('.notification-text');
    if (notificationEl) {
        const notificationMessages = [
            "Jemand aus München hat gerade Prinzessin bestellt",
            "Jemand aus Düsseldorf hat gerade 2 Bücher bestellt",
            "Jemand aus Hamburg hat gerade Prinzessin bestellt",
            "Jemand aus Berlin hat gerade Meerjungfrau bestellt"
        ];
        
        let notifIndex = 0;
        
        setInterval(() => {
            notificationEl.classList.add('slide-out');
            setTimeout(() => {
                notifIndex = (notifIndex + 1) % notificationMessages.length;
                notificationEl.innerText = notificationMessages[notifIndex];
                
                notificationEl.classList.remove('slide-out');
                notificationEl.classList.add('teleport');
                
                void notificationEl.offsetWidth; 
                
                notificationEl.classList.remove('teleport');
            }, 400); 
        }, 4500); 
    }

    // --- Data Definition ---
    // const hairColors = [
    //     { id: "light_blonde", label: "Hellblond", hex: "#F3E5AB" },
    //     { id: "blonde", label: "Blond", hex: "#D6B874" },
    //     { id: "dark_blonde", label: "Dunkelblond", hex: "#A8834C" },
    //     { id: "light_brown", label: "Hellbraun", hex: "#855E38" },
    //     { id: "brown", label: "Braun", hex: "#4A3018" },
    //     { id: "black", label: "Schwarz", hex: "#1A1A1A" },
    //     { id: "red", label: "Rot", hex: "#A33C1B" }
    // ];

    const eyeColors = [
        { id: "light_blue", label: "Hellblau", hex: "#99C2E3" },
        { id: "blue", label: "Blau", hex: "#4A7BB0" },
        { id: "green", label: "Grün", hex: "#5E9E67" },
        { id: "hazel", label: "Haselnuss", hex: "#9E824A" },
        { id: "brown", label: "Braun", hex: "#5E3A1A" },
        { id: "dark_brown", label: "Dunkelbraun", hex: "#2E1A0C" },
        { id: "gray", label: "Grau", hex: "#86949C" }
    ];

    let orderData = {
        theme: themeName || "Abenteuer", 
        childName: "",
        gender: "",
        hairColorId: "", 
        eyeColorId: "",
        photoUrl: "", 
        bindingType: "",
        bindingPrice: 0,
        hasDedication: false,
        dedicationMessage: "",
        dedicationPrice: 3.99,
        hasPremiumPaper: false,
        premiumPaperPrice: 4.99,
        additionalBooks: [],
        isFallback: false
    };

    // --- PHASE 1: Child Details ---
    function renderPhase1() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step" id="phase-1">
                ${getStepIndicatorHTML(1)}
                <h2>Für wen ist das Buch?</h2>
                <div class="form-group">
                    <label>Vorname</label>
                    <input type="text" id="input-name" placeholder="z.B. Emilia">
                </div>
                <div class="form-group">
                    <label>Geschlecht</label>
                    <div class="segmented-control">
                        <div class="segmented-option" data-gender="Boy">👦 Junge</div>
                        <div class="segmented-option" data-gender="Girl">👧 Mädchen</div>
                    </div>
                </div>
                <!-- <div class="form-group">
                    <label>Haarfarbe</label>
                    <div class="palette-grid" id="hair-palette"></div>
                </div> -->
                <div class="form-group">
                    <label>Augenfarbe</label>
                    <div class="palette-grid" id="eye-palette"></div>
                </div>
                <div style="height: 20px;"></div> 
            </div>
            <div class="sticky-footer">
                <button id="btn-next-2" class="primary-btn" disabled>Weiter →</button>
            </div>
        `;

        // const hairGrid = document.getElementById("hair-palette");
        // hairColors.forEach(hair => {
        //     hairGrid.innerHTML += `
        //         <div class="palette-item" data-hair-id="${hair.id}">
        //             <div class="swatch-box" style="background-color: ${hair.hex};"></div>
        //             <div class="swatch-label">${hair.label}</div>
        //         </div>
        //     `;
        // });

        const eyeGrid = document.getElementById("eye-palette");
        eyeColors.forEach(eye => {
            eyeGrid.innerHTML += `
                <div class="palette-item" data-eye-id="${eye.id}">
                    <div class="swatch-box svg-container">
                        <svg width="100%" height="100%" viewBox="0 0 120 120" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
                            <path d="M10 60 C25 25, 95 25, 110 60 C95 95, 25 95, 10 60 Z" fill="white" stroke="#c8c8c8" stroke-width="2"/>
                            <circle cx="60" cy="60" r="22" fill="${eye.hex}" />
                            <circle cx="60" cy="60" r="10" fill="#1c1c1c" />
                            <circle cx="66" cy="54" r="5" fill="white" fill-opacity="0.8"/>
                            <ellipse cx="69" cy="69" rx="1.5" ry="3.5" fill="white" fill-opacity="0.3" transform="rotate(30, 69, 69)"/>
                        </svg>
                    </div>
                    <div class="swatch-label">${eye.label}</div>
                </div>
            `;
        });

        document.getElementById('input-name').addEventListener('input', (e) => {
            orderData.childName = e.target.value.trim();
            validateForm();
        });

        const genderOptions = document.querySelectorAll('.segmented-option');
        genderOptions.forEach(option => {
            option.addEventListener('click', () => {
                genderOptions.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');
                orderData.gender = option.dataset.gender;
                validateForm(); 
            });
        });

        // const hairOptions = document.querySelectorAll('#hair-palette .palette-item');
        // hairOptions.forEach(option => {
        //     option.addEventListener('click', () => {
        //         hairOptions.forEach(opt => opt.classList.remove('is-selected'));
        //         option.classList.add('is-selected');
        //         orderData.hairColorId = option.dataset.hairId;
        //         validateForm();
        //     });
        // });

        const eyeOptions = document.querySelectorAll('#eye-palette .palette-item');
        eyeOptions.forEach(option => {
            option.addEventListener('click', () => {
                eyeOptions.forEach(opt => opt.classList.remove('is-selected'));
                option.classList.add('is-selected');
                orderData.eyeColorId = option.dataset.eyeId;
                validateForm();
            });
        });

        function validateForm() {
            const btn = document.getElementById('btn-next-2');
            if (orderData.childName && orderData.gender && orderData.eyeColorId) {
                btn.disabled = false;
            } else {
                btn.disabled = true;
            }
        }

        document.getElementById('btn-next-2').addEventListener('click', () => {
            renderPhase2(); 
        });
    }

    // --- PHASE 2: Photo Upload ---
    function renderPhase2() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step" id="phase-2">
                ${getStepIndicatorHTML(2)}
                <h2 style="margin-bottom: 10px;">Lade ein Foto von ${orderData.childName} hoch</h2>
                <div class="dropzone" id="photo-dropzone" style="border-color: #fc765bff;">
                    <input type="file" id="input-photo" accept="image/jpeg, image/png, image/webp">
                    <div id="dropzone-text">
                        <div class="upload-btn" style="background-color: #fc765bff; color: white; border-color: #fc765bff;">Foto auswählen</div>
                        <p style="font-size: 14px; color: #666; margin: 0;">oder hierher ziehen & ablegen</p>
                    </div>
                    <img id="preview-image" class="preview-image" src="" alt="Vorschau">
                </div>
                <label class="consent-wrapper">
                    <input type="checkbox" id="input-consent" style="accent-color: #fc765bff;">
                    <span>Ich bestätige, dass ich berechtigt bin, dieses Foto zu verwenden. Details in der Datenschutzerklärung.</span>
                </label>
                <div class="tips-card">
                    <div class="tips-header">
                        <h3>✨ Tipps für das perfekte Foto</h3>
                        <p>Das Gesicht sollte gut sichtbar sein – keine Mützen, Schnuller, Sonnenbrillen oder Grimassen.</p>
                    </div>
                    <div class="tips-grid">
                        <div class="tip-item">
                            <div class="tip-image-box good tip-1" style="background-image: url('https://cdn.shopify.com/s/files/1/1022/4943/1389/files/1.jpg?v=1775914601');">
                                <div class="tip-icon good">✓</div>
                            </div>
                            <div class="tip-label">Scharf & gut beleuchtet</div>
                        </div>
                        <div class="tip-item">
                            <div class="tip-image-box bad" style="background-image: url('https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2.jpg?v=1775914669');">
                                <div class="tip-icon bad">✕</div> 
                            </div>
                            <div class="tip-label">Mehrere Personen</div>
                        </div>
                    </div>
                </div>
                <div style="height: 10px;"></div> 
            </div>
            <div class="sticky-footer">
                <button id="btn-back-1" class="secondary-btn">← Zurück</button>
                <button id="btn-next-3" class="primary-btn" disabled>Weiter →</button>
            </div>
        `;

        const dropzone = document.getElementById('photo-dropzone');
        const fileInput = document.getElementById('input-photo');
        const consentCheckbox = document.getElementById('input-consent');
        const nextBtn = document.getElementById('btn-next-3');
        const backBtn = document.getElementById('btn-back-1');
        const previewImage = document.getElementById('preview-image');
        const dropzoneText = document.getElementById('dropzone-text');

        function validatePhase2() {
            if (orderData.photoUrl && consentCheckbox.checked) {
                nextBtn.disabled = false;
            } else {
                nextBtn.disabled = true;
            }
        }

        function processFile(file) {
            if (!file || !file.type.startsWith('image/')) {
                alert('Bitte lade ein gültiges Bild hoch (JPG, PNG).');
                return;
            }
            
            const reader = new FileReader();
            reader.onload = (e) => {
                orderData.photoUrl = e.target.result; 
                previewImage.src = e.target.result;
                previewImage.style.display = 'block';
                dropzoneText.style.display = 'none';
                dropzone.style.borderColor = '#22c55e';
                dropzone.style.background = '#f0fdf4'; 
                validatePhase2();
            };
            reader.readAsDataURL(file); 
        }

        fileInput.addEventListener('change', (e) => { processFile(e.target.files[0]); });
        dropzone.addEventListener('click', () => { fileInput.click(); });
        dropzone.addEventListener('dragover', (e) => { e.preventDefault(); dropzone.classList.add('dragover'); });
        dropzone.addEventListener('dragleave', () => { dropzone.classList.remove('dragover'); });
        dropzone.addEventListener('drop', (e) => {
            e.preventDefault();
            dropzone.classList.remove('dragover');
            if (e.dataTransfer.files.length) {
                fileInput.files = e.dataTransfer.files; 
                processFile(e.dataTransfer.files[0]);
            }
        });

        consentCheckbox.addEventListener('change', validatePhase2);
        backBtn.addEventListener('click', () => { renderPhase1(); });
        nextBtn.addEventListener('click', () => { renderPhase3(); });
    }

    // --- PHASE 3: Dynamic Loading Screen ---
    function renderPhase3() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step" id="phase-3">
                <div class="loading-header">
                    <h2 id="dynamic-heading">Deine Vorschau wird erstellt...</h2>
                    <p>Dein Foto wird in einen einzigartigen Buchcharakter verwandelt.</p>
                </div>
                <div class="progress-container">
                    <div class="progress-ring-wrapper">
                        <svg class="progress-ring" width="120" height="120">
                            <circle class="progress-ring__circle-bg" stroke-width="8" fill="transparent" r="54" cx="60" cy="60"/>
                            <circle class="progress-ring__circle" stroke-width="8" fill="transparent" r="54" cx="60" cy="60"/>
                        </svg>
                        <div class="progress-text" id="progress-text">0%</div>
                    </div>
                    <div class="progress-time">Dauert etwa 30 Sekunden</div>
                </div>
                <div class="social-proof">
                    <div class="avatar-group">
                        <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833" alt="User">
                        <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/1_7e1c1b2e-17a5-46e1-b383-30130a54b091.jpg?v=1778417832" alt="User">
                        <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/3_7319c4e4-17a5-41f4-b7b9-7a4d58bd938e.jpg?v=1778417832" alt="User">
                    </div>
                    <span>Über 3.000 erstellte Bücher</span>
                </div>
                <div class="review-card" id="dynamic-review">
                    <div id="review-slider" class="review-slider">
                            <div class="review-header">
                                <img id="review-img" src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833" alt="Reviewer">
                                <div>
                                    <div class="review-name" id="review-name">Julia B.</div>
                                    <div class="review-stars">★★★★★</div>
                                </div>
                            </div>
                        <div class="review-text" id="review-text">
                            "Meine Tochter hat sich sofort wiedererkannt und gerufen: 'Mama, das bin ja ich!' Es ist jetzt ihr absolutes Lieblingsbuch."
                        </div>
                    </div>
                </div>
            </div>
        `;

        const circle = document.querySelector('.progress-ring__circle');
        const progressText = document.getElementById('progress-text');
        const radius = circle.r.baseVal.value;
        const circumference = radius * 2 * Math.PI;
        circle.style.strokeDasharray = `${circumference} ${circumference}`;
        circle.style.strokeDashoffset = circumference;

        function setProgress(percent) {
            const offset = circumference - percent / 100 * circumference;
            circle.style.strokeDashoffset = offset;
            if (percent >= 100) progressText.innerText = "100%";
            else progressText.innerText = `${percent.toFixed(0)}%`;
        }

        let startTime = Date.now();
        const expectedDuration = 80000;

        const progressInterval = setInterval(() => {
            let elapsedTime = Date.now() - startTime;
            let timeFraction = elapsedTime / expectedDuration;
            
            // Prevent the fraction from going over 1 if the backend takes longer than expectedDuration
            if (timeFraction > 1) timeFraction = 1; 

            let easeProgress = 1 - Math.pow(1 - timeFraction, 3);
            let currentProgress = easeProgress * 100;
            
            // 2. Cap the visual progress at 99% so it never looks finished while waiting
            if (currentProgress > 99) currentProgress = 99; 
            
            setProgress(currentProgress);
        }, 100);

        const headings = [
            "Deine Vorschau wird erstellt...",
            "Gleich ist es soweit einen Moment…",
            "Dein Abenteuer nimmt Gestalt an...",
            "Wir erwecken deinen Helden zum Leben...",
            "Dein Wunder ist fast fertig..."
        ];

        const reviews = [
            { name: "Julia B.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/2_707ebc48-3da2-4c44-9551-b408a6097a90.jpg?v=1778417833", text: "Meine Tochter hat sich sofort wiedererkannt und gerufen: 'Mama, das bin ja ich!' Es ist jetzt ihr absolutes Lieblingsbuch." },
            { name: "Klaus W.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/3_7319c4e4-17a5-41f4-b7b9-7a4d58bd938e.jpg?v=1778417832", text: "Ein Geburtstagsgeschenk für meinen Sohn – er war sprachlos. Er zeigt das Buch jedem Besuch. Die Qualität ist hervorragend." },
            { name: "Helga S.", img: "https://cdn.shopify.com/s/files/1/1022/4943/1389/files/1_7e1c1b2e-17a5-46e1-b383-30130a54b091.jpg?v=1778417832", text: "Ich war skeptisch, ein Foto hochzuladen. Aber das Ergebnis hat mich umgehauen – die Ähnlichkeit ist wirklich verblüffend!" }
        ];

        let tick = 0;
        const textInterval = setInterval(() => {
            tick++;
            document.getElementById('dynamic-heading').innerText = headings[tick % headings.length];
            if(tick % 2 === 0) {
                const slider = document.getElementById('review-slider');
                slider.classList.add('sliding-out');
                setTimeout(() => {
                    const rev = reviews[(tick / 2) % reviews.length];
                    document.getElementById('review-name').innerText = rev.name;
                    document.getElementById('review-img').src = rev.img; 
                    document.getElementById('review-text').innerText = `"${rev.text}"`;
                    
                    slider.classList.remove('sliding-out');
                    slider.classList.add('sliding-in');
                    void slider.offsetWidth; 
                    slider.classList.remove('sliding-in');
                }, 400); 
            }
        }, 3500);

        // --- NEW LOGIC: Upload to ImageKit First ---
        // ImageKit accepts the full base64 Data URI directly
        const fileData = orderData.photoUrl; 
        
        // ⚠️ Replace with your ImageKit Private API Key
        const imageKitPrivateKey = 'private_0CDmak9pJcnYMYC3TwOgAoL0BMc='; 
        
        // ImageKit requires the key to be Base64 encoded for the Authorization header
        const encodedAuth = btoa(imageKitPrivateKey + ':');

        const formData = new FormData();
        formData.append('file', fileData);
        formData.append('fileName', `storybook_photo_${Date.now()}.jpg`);

        fetch('https://upload.imagekit.io/api/v1/files/upload', {
            method: 'POST',
            headers: {
                'Authorization': `Basic ${encodedAuth}`
            },
            body: formData
        })
        .then(response => response.json())
        .then(imageKitResult => {
            // ImageKit returns an error message property if it fails
            if (imageKitResult.message) {
                throw new Error("ImageKit upload failed: " + imageKitResult.message);
            }
            
            // ImageKit directly provides the URL at the root of the response object
            const uploadedPhotoUrl = imageKitResult.url;
            
            // 👇 THE FIX: Directly update the global orderData here so Phase 7 sees the short URL!
            orderData.photoUrl = uploadedPhotoUrl; 
            orderData.imgbbLink = uploadedPhotoUrl; // Kept as 'imgbbLink' so Phase 7 and Formspree don't break

            // Now trigger the n8n Webhook with the newly updated object
            return fetch(n8nWebhook, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(orderData)
            });
        })
        .then(response => response.json())
        .then(data => {
            clearInterval(progressInterval);
            clearInterval(textInterval);
            setProgress(100); 
            setTimeout(() => {
                orderData.resultCharacter = data.characterUrl; 
                orderData.resultInside = data.insideUrl;
                // orderData.imgbbLink is already cleanly set above
                renderPhase4(); 
            }, 800);
        })
        // Replace your existing .catch() in renderPhase3() with this:
        .catch(error => {
            console.error("Pipeline Error:", error);
            clearInterval(progressInterval);
            clearInterval(textInterval);
            setProgress(100);

            // --- RELIABLE FORMSPREE FALLBACK ---
            fetch('https://formspree.io/f/mdaqnzav', {
                method: 'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    'Accept': 'application/json' 
                },
                body: JSON.stringify({
                    subject: "🚨 Alert: Fallback Image Displayed",
                    childName: orderData.childName,
                    errorMsg: error.message || "n8n timeout or unreachable",
                    // Using your preferred English keys for consistency
                    dedicationText: orderData.hasDedication ? orderData.dedicationMessage : "None", 
                    photoUrl: orderData.imgbbLink
                })
            }).catch(e => console.error("Fallback notification failed", e));

            setTimeout(() => {
                orderData.isFallback = true; 
                orderData.resultCharacter = 'https://images.unsplash.com/photo-1555252848-d30e5509c916?w=600&auto=format&fit=crop'; 
                orderData.resultInside = 'https://cdn.shopify.com/s/files/1/1022/4943/1389/files/fallback_image.jpg?v=1779217709';
                renderPhase4();
            }, 1500);
        });
    }

    // --- PHASE 4: Live Preview Rendering ---
    function renderPhase4() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step preview-step">
                ${getStepIndicatorHTML(3)}
                <h2>So wird dein Buch aussehen</h2>
                <p class="preview-description">Hier siehst du bereits eine Vorschau, wie der Charakter deines Kindes aussehen wird – inklusive der ersten Buchseite. Nach dem Kauf wird der Charakter automatisch in alle Seiten des Buches integriert. 🎨</p>
                <div class="accordion-wrapper">
                    <button class="accordion-header" id="details-accordion-btn">
                        <span>Details</span>
                        <svg class="chevron-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round">
                            <polyline points="6 9 12 15 18 9"></polyline>
                        </svg>
                    </button>
                    <div class="accordion-content" id="details-accordion-content">
                        <div class="book-specs-grid">
                            <div class="spec-item"><span class="spec-check">✓</span> 32 Seiten</div>
                            <div class="spec-item"><span class="spec-check">✓</span> 21 x 21 cm</div>
                            <div class="spec-item"><span class="spec-check">✓</span> 360°Spiegelbuch-Technologie</div>
                            <div class="spec-item"><span class="spec-check">✓</span> Gedruckt in Deutschland</div>
                            <div class="spec-item"><span class="spec-check">✓</span> Perfekt für das Alter von 1-12</div>
                            <div class="spec-item"><span class="spec-check">✓</span> Hochwertige Illustrationen</div>
                            <div class="spec-item"><span class="spec-check">✓</span> Langlebige Materialien</div>
                            <div class="spec-item"><span class="spec-check">✓</span> Gedruckt in 2-4 Tagen</div>
                        </div>
                    </div>
                </div>
                <div class="generated-image-stack">
                    <img src="${orderData.resultCharacter}" alt="Character Preview">
                    <img src="${orderData.resultInside}" alt="Inside Page">
                </div>
                
                <div style="background-color: #ffffff; border-radius: 8px; padding: 16px; margin-top: 16px; text-align: center; font-size: 14px; line-height: 1.5; color: #334155; box-shadow: 0 1px 3px rgba(0,0,0,0.1); border: 1px solid #e2e8f0;">
                    Die restlichen 34 Seiten warten schon auf dich! Nach dem Kauf verschwinden die verpixelten Stellen sofort – unser Designerteam zaubert deinen Charakter liebevoll in jede einzelne Szene. ✨
                </div>

                <div style="height: 140px;"></div>
            </div>
            
            <div class="sticky-footer" style="display: flex; flex-direction: column; gap: 12px; background: #fff; padding: 15px 20px; box-shadow: 0 -4px 12px rgba(0,0,0,0.08);">
                ${orderData.isFallback ? `
                <button id="btn-try-again" style="background-color: #fff1f2; color: #e11d48; border: 2px solid #fda4af; padding: 14px; border-radius: 12px; font-weight: bold; font-size: 15px; cursor: pointer; display: flex; align-items: center; justify-content: center; gap: 8px; width: 100%; transition: opacity 0.2s;">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"></path>
                        <path d="M3 3v5h5"></path>
                    </svg>
                    Anderes Foto hochladen
                </button>` : ''}
                <button id="btn-next-4" class="primary-btn blue" style="width: 100%;">Weiter →</button>
            </div>
        `;

        const accordionBtn = document.getElementById('details-accordion-btn');
        const accordionContent = document.getElementById('details-accordion-content');

        accordionBtn.addEventListener('click', () => {
            accordionBtn.classList.toggle('active');
            if (accordionBtn.classList.contains('active')) {
                accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";
            } else {
                accordionContent.style.maxHeight = null;
            }
        });

        if (orderData.isFallback) {
            document.getElementById('btn-try-again').addEventListener('click', () => {
                orderData.isFallback = false; // Reset the flag
                renderPhase2(); // Send them back to photo upload
            });
        }

        document.getElementById('btn-next-4').addEventListener('click', () => {
            renderPhase5();
        });
    }

    // --- PHASE 5: Binding Selection ---
    function renderPhase5() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step binding-step" id="phase-5">
                ${getStepIndicatorHTML(4)}
                <h2 class="serif-heading">Welche Einbandart soll dein Buch haben?</h2>
                <div class="binding-grid">
                    <div class="binding-card">
                        <div class="image-wrapper">
                            <div class="binding-badge green">Meistgewählt</div>
                            <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/hardcover.png?v=1775992868" alt="Hardcover">
                        </div>
                        <div class="binding-content">
                            <h3>Hardcover</h3>
                            <div class="binding-price">€39.99</div>
                            <p>Für hunderte Geschichten gemacht, bleibt wie neu. Zum Immer wieder Lesen und für immer behalten.</p>
                            <button class="primary-btn choose-binding-btn" data-type="Hardcover" data-price="39.99">Auswählen</button>
                        </div>
                    </div>
                    <div class="binding-card">
                        <div class="image-wrapper">
                            <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/softcover.png?v=1775992868" alt="Softcover">
                        </div>
                        <div class="binding-content">
                            <h3>Softcover</h3>
                            <div class="binding-price">€29.99</div>
                            <p>Leicht und flexibel – perfekt für kleine Hände und unterwegs.</p>
                            <button class="primary-btn choose-binding-btn" data-type="Softcover" data-price="29.99">Auswählen</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const bindingBtns = document.querySelectorAll('.choose-binding-btn');
        bindingBtns.forEach(btn => {
            btn.addEventListener('click', (e) => {
                orderData.bindingType = e.target.dataset.type;
                orderData.bindingPrice = parseFloat(e.target.dataset.price);
                renderPhase6(); 
            });
        });
    }

    // --- PHASE 6: Extras / Upsells ---
    function renderPhase6() {
        forceScrollToTop();
        
        const salutation = orderData.gender === 'Boy' ? 'Lieber' : 'Liebe';
        const heroPhrase = orderData.gender === 'Boy' ? 'An unseren kleinen Helden' : 'An unsere kleine Heldin';

        const preMadeMessages = [
            `${salutation} ${orderData.childName}, Oma und Opa wünschen dir alles Gute zum Geburtstag! Viel Spaß bei deinem großen Abenteuer.`,
            `Alles Gute zum Geburtstag, ${orderData.childName}! Wir haben dich unendlich lieb. Genieß deine magische Geschichte.`,
            `${heroPhrase}, ${orderData.childName}. Bleib immer so mutig, freundlich und voller Neugier.`
        ];
        // Check if there's a saved message and if it's a custom one
        const isCustomMessage = orderData.hasDedication && !preMadeMessages.includes(orderData.dedicationMessage);
        const customText = isCustomMessage ? orderData.dedicationMessage : "";

        root.innerHTML = `
            <div class="funnel-step extras-step" id="phase-6">
                ${getStepIndicatorHTML(5)}
                <h2 class="serif-heading">Möchtest du Extras hinzufügen?</h2>
                <div class="extra-card">
                    <div class="image-wrapper">
                        <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/dedication.png?v=1775995460" alt="Personal dedication">
                    </div>
                    <div class="extra-content">
                        <div class="extra-header">
                            <h3>Persönliche Widmung</h3>
                            <div class="extra-price">+ €3.99</div>
                        </div>
                        <div class="binding-badge green inline-badge">75% wählen diese Option</div>
                        <p>Deine Worte auf der ersten Seite machen das Buch zu einem echten Erinnerungsstück.</p>
                        
                        <div class="dedication-stacked-layout" style="margin-top: 16px;">
                            <textarea id="custom-dedication" placeholder="Schreibe etwas Besonderes für ${orderData.childName}..." maxlength="200" style="margin-bottom: 4px;">${customText}</textarea>
                            <div class="char-count" style="margin-bottom: 20px;"><span id="char-current">${customText.length}</span> / 200 Zeichen übrig</div>
                            
                            <p style="font-size: 13px; font-weight: bold; color: #334155; margin-bottom: 12px;">Oder wähle eine fertige Nachricht:</p>
                            
                            <div class="message-grid">
                                ${preMadeMessages.map((msg) => `
                                    <div class="message-option" data-msg="${msg}">
                                        <span class="quote-mark">"</span>
                                        <p>${msg}</p>
                                        <div class="radio-circle"></div>
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="extra-card">
                    <div class="image-wrapper short">
                        <img src="https://cdn.shopify.com/s/files/1/1022/4943/1389/files/hardcover.png?v=1775992868" alt="Premium Paper">
                    </div>
                    <div class="extra-content">
                        <div class="extra-header">
                            <h3>Premium-Papier</h3>
                            <div class="extra-price">+ €4.99</div>
                        </div>
                        <p>50% dicker – fühlt sich noch hochwertiger an und hält länger.</p>
                        
                        <label class="premium-toggle">
                            <input type="checkbox" id="premium-paper-check">
                            <span class="toggle-box">Premium-Papier hinzufügen</span>
                        </label>
                    </div>
                </div>
                <div style="height: 20px;"></div>
            </div>
            <div class="sticky-footer">
                <button id="btn-back-to-binding" class="secondary-btn">← Zurück</button>
                <button id="btn-continue-checkout" class="primary-btn blue">Weiter →</button>
            </div>
        `;

        const messageOptions = document.querySelectorAll('.message-option');
        const customArea = document.getElementById('custom-dedication');
        const premiumCheck = document.getElementById('premium-paper-check');
        const charCurrent = document.getElementById('char-current');

        messageOptions.forEach(option => {
            option.addEventListener('click', () => {
                messageOptions.forEach(opt => opt.classList.remove('selected'));
                option.classList.add('selected');
                orderData.hasDedication = true;
                orderData.dedicationMessage = option.dataset.msg;
                customArea.value = ""; 
                charCurrent.innerText = "0";
            });
        });

        customArea.addEventListener('input', (e) => {
            const text = e.target.value;
            charCurrent.innerText = text.length;
            if (text.trim().length > 0) {
                orderData.hasDedication = true;
                orderData.dedicationMessage = text;
                messageOptions.forEach(opt => opt.classList.remove('selected'));
            } else {
                orderData.hasDedication = false;
                orderData.dedicationMessage = "";
            }
        });

        premiumCheck.addEventListener('change', (e) => {
            orderData.hasPremiumPaper = e.target.checked;
        });

        // Restore pre-made message selection if applicable
        if (orderData.hasDedication && !isCustomMessage) {
            const selectedOpt = Array.from(messageOptions).find(opt => opt.dataset.msg === orderData.dedicationMessage);
            if (selectedOpt) selectedOpt.classList.add('selected');
        }

        document.getElementById('btn-back-to-binding').addEventListener('click', renderPhase5);
        document.getElementById('btn-continue-checkout').addEventListener('click', () => {
            renderPhase7(); 
        });
    }

    // --- PHASE 7: Cross-sell / Checkout ---
    function renderPhase7() {
        forceScrollToTop();
        root.innerHTML = `
            <div class="funnel-step bundle-step" id="phase-7" style="text-align:center; padding: 60px 20px;">
                ${getStepIndicatorHTML(6)}
                <h2 class="serif-heading">Sonderangebote werden geladen...</h2>
                <p style="color: #64748b;">Einen Moment, wir schauen in unseren Regalen nach.</p>
            </div>
        `;

        let collectionHandle = orderData.gender === "Boy" ? "jungs" : "madchen"; 

        // UPDATED: Fetch BOTH the Upsell Collection AND the entire Store Catalog
        Promise.all([
            fetch(`/collections/${collectionHandle}/products.json`).then(res => res.json()),
            fetch(`/products.json?limit=250`).then(res => res.json())
        ])
        .then(([collectionData, allProductsData]) => {
            // Get the ID of the main book from the URL
            let baseIdNumber = dynamicBaseId ? Number(dynamicBaseId) : null;
            
            const catalogBooks = [];

            // Loop through the collection, but FILTER OUT the main book
            collectionData.products.forEach(product => {
                // Check if this product's ID (or any of its variants) matches the main book
                let isMainBook = (product.id === baseIdNumber) || product.variants.some(v => v.id === baseIdNumber);
                
                // Only add it to the upsell list if it is NOT the main book
                if (!isMainBook) {
                    let originalImg = product.images[0] ? product.images[0].src : '';
                    let fastLoadingImg = originalImg.replace(/\.(png|jpg|jpeg|gif|webp)/i, '_400x.$1');
                    
                    catalogBooks.push({
                        id: product.id, 
                        title: product.title,
                        img: fastLoadingImg,
                        variants: product.variants 
                    });
                }
            });
            
            // Pass the entire store catalog to the UI function
            const allStoreBooks = allProductsData.products;
            buildPhase7UI(catalogBooks, allStoreBooks);
        })
        .catch(error => {
            console.error("Error fetching live upsells:", error);
            root.innerHTML = `
                <div class="funnel-step" style="text-align:center; padding: 60px 20px;">
                    <h2 class="serif-heading">Bereit für die Kasse!</h2>
                    <button id="btn-skip-error" class="primary-btn blue">Weiter zum Warenkorb →</button>
                </div>
            `;
            document.getElementById('btn-skip-error')?.addEventListener('click', () => {
                console.log("Proceeding without upsells:", orderData);
            });
        });
    }
    function buildPhase7UI(catalogBooks, allStoreBooks) {
        // --- DYNAMIC PRICING BASED ON BINDING ---
        const isSoftcover = orderData.bindingType === "Softcover";
        const basePrice = isSoftcover ? 29.99 : 39.99;
        const tier2Price = isSoftcover ? 22.49 : 29.99;
        const tier3Price = isSoftcover ? 17.99 : 23.99;
        
        const originalPrice = isSoftcover ? 39.90 : 49.90;

        root.innerHTML = `
            <div class="funnel-step bundle-step" id="phase-7">
                ${getStepIndicatorHTML(6)}
                <h2 class="serif-heading">Lust auf ein weiteres Abenteuer?</h2>
                <p style="text-align: center; color: #64748b; margin-top: -20px; margin-bottom: 30px; font-size: 14px;">Gleiches Kind, neue Geschichte – Name und Aussehen bleiben gleich.</p>
                
                <div class="tier-header-container">
                    <div class="tier-box" id="tier-3">
                        <div class="tier-badge rainbow">Beliebtestes</div>
                        <strong>Ab 3. Buch</strong>
                        <div class="tier-price">€${tier3Price.toFixed(2)}</div>
                        <div class="tier-save green">40% sparen</div>
                        <div class="bottom-overlap-badge">Gratis Versand</div>
                    </div>
                    <div class="tier-box" id="tier-2">
                        <div class="tier-badge blue">Bester Preis</div>
                        <strong>2. Buch</strong>
                        <div class="tier-price">€${tier2Price.toFixed(2)}</div>
                        <div class="tier-save green">25% sparen</div>
                        <div class="bottom-overlap-badge">Gratis Versand</div>
                    </div>
                    <div class="tier-box active" id="tier-1">
                        <strong>1 Buch</strong>
                        <div class="tier-price">€${basePrice.toFixed(2)}</div>
                        <div class="tier-save" style="text-decoration: line-through; text-decoration-color: #94a3b8; color: #94a3b8; font-size: 14px; font-weight: 500;">
                            €${originalPrice.toFixed(2)}
                        </div>
                    </div>
                </div>

                <div class="savings-bar">
                    DU SPARST: <span id="total-savings">€0.00</span>
                </div>

                <div class="upsell-grid">
                    ${catalogBooks.map(book => `
                        <div class="upsell-card" data-id="${book.id}">
                            <div class="upsell-img-wrapper">
                                <img src="${book.img}" alt="${book.title}">
                            </div>
                            <div class="upsell-content">
                                <h4>${book.title}</h4>
                                <div class="upsell-pricing" style="margin-top: -5px; margin-bottom: 8px; display: flex; align-items: center; justify-content: center; gap: 6px;">
                                    <span class="upsell-new-price" style="font-size: 14px; font-weight: bold; color: #fc765bff;">+ €${tier2Price.toFixed(2)}</span>
                                    <span class="upsell-discount-tag" style="background: #22c55e; color: white; padding: 2px 6px; border-radius: 4px; font-size: 11px; font-weight: bold;">-25%</span>
                                </div>
                                <label class="upsell-checkbox-btn">
                                    <input type="checkbox" class="upsell-check" value="${book.id}">
                                    <span>Auswählen</span>
                                </label>
                            </div>
                        </div>
                    `).join('')}
                </div>
                <div style="height: 100px;"></div> 
            </div>
            <div class="sticky-footer">
                <button id="btn-back-to-extras" class="secondary-btn">← Zurück</button>
                <button id="btn-final-checkout" class="primary-btn green">In den Warenkorb</button>
            </div>
        `;

        const checkboxes = document.querySelectorAll('.upsell-check');
        const savingsText = document.getElementById('total-savings');
        const tier1 = document.getElementById('tier-1');
        const tier2 = document.getElementById('tier-2');
        const tier3 = document.getElementById('tier-3');

        function updatePricing() {
            orderData.additionalBooks = [];
            
            let numExtraBooks = document.querySelectorAll('.upsell-check:checked').length;
            let checkedCounter = 0; 

            checkboxes.forEach((box) => {
                const card = box.closest('.upsell-card');
                const newPriceEl = card.querySelector('.upsell-new-price');
                const tagEl = card.querySelector('.upsell-discount-tag');

                if (box.checked) {
                    orderData.additionalBooks.push(box.value); 
                    card.classList.add('selected');
                    checkedCounter++; 
                    
                    if (checkedCounter === 1) {
                        newPriceEl.innerText = `+ €${tier2Price.toFixed(2)}`;
                        tagEl.innerText = "-25%";
                        tagEl.style.background = "#22c55e"; 
                        tagEl.style.color = "white";
                    } else {
                        newPriceEl.innerText = `+ €${tier3Price.toFixed(2)}`;
                        tagEl.innerText = "-40%";
                        tagEl.style.background = "linear-gradient(90deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)"; 
                        tagEl.style.color = "#1a1a1a";
                    }
                } else {
                    card.classList.remove('selected');
                    
                    if (numExtraBooks === 0) {
                        newPriceEl.innerText = `+ €${tier2Price.toFixed(2)}`;
                        tagEl.innerText = "-25%";
                        tagEl.style.background = "#22c55e"; 
                        tagEl.style.color = "white";
                    } else {
                        newPriceEl.innerText = `+ €${tier3Price.toFixed(2)}`;
                        tagEl.innerText = "-40%";
                        tagEl.style.background = "linear-gradient(90deg, #ff9a9e 0%, #fecfef 99%, #fecfef 100%)"; 
                        tagEl.style.color = "#1a1a1a";
                    }
                }
            });

            let totalSavings = 0;
            if (numExtraBooks >= 1) totalSavings += (basePrice - tier2Price); 
            if (numExtraBooks >= 2) totalSavings += ((basePrice - tier3Price) * (numExtraBooks - 1));
            
            savingsText.innerText = `€${totalSavings.toFixed(2)}`;

            tier1.classList.remove('active');
            tier2.classList.remove('active');
            tier3.classList.remove('active');

            if (numExtraBooks === 0) tier1.classList.add('active');
            else if (numExtraBooks === 1) tier2.classList.add('active');
            else tier3.classList.add('active');
        }

        checkboxes.forEach(box => box.addEventListener('change', updatePricing));
        document.getElementById('btn-back-to-extras').addEventListener('click', renderPhase6);
        
        // THE FINAL CHECKOUT BUTTON
        document.getElementById('btn-final-checkout').addEventListener('click', () => {
            const finalBtn = document.getElementById('btn-final-checkout');
            finalBtn.innerText = "Wird verarbeitet...";
            finalBtn.style.opacity = "0.7";
            finalBtn.disabled = true; 
            
            let itemsToAdd = [];

            const PREMIUM_PAPER_VARIANT_ID = 64156843999581;
            const DEDICATION_VARIANT_ID = 64156840722781;

            if (orderData.hasPremiumPaper) {
                itemsToAdd.push({ id: PREMIUM_PAPER_VARIANT_ID, quantity: 1 });
            }
            if (orderData.hasDedication) {
                itemsToAdd.push({ 
                    id: DEDICATION_VARIANT_ID, 
                    quantity: 1,
                    properties: {
                        "Deine Widmung": orderData.dedicationMessage
                    }
                });
            }

            let upsellCounter = 0;
            if (orderData.additionalBooks && orderData.additionalBooks.length > 0) {
                orderData.additionalBooks.forEach(productId => {
                    let bookData = catalogBooks.find(b => b.id == Number(productId));
                    if (bookData) {
                        upsellCounter++;
                        
                        let targetTier = upsellCounter === 1 ? "Tier 2" : "Tier 3";
                        let targetBinding = orderData.bindingType; 

                        let matchedVariant = bookData.variants.find(v => 
                            v.title.includes(targetBinding) && v.title.includes(targetTier)
                        );

                        let variantIdToAdd = matchedVariant ? matchedVariant.id : bookData.variants[0].id;

                        itemsToAdd.push({ 
                            id: variantIdToAdd, 
                            quantity: 1,
                            properties: {
                                "_Child's Name": orderData.childName,
                                "_Gender": orderData.gender,
                                "_Eye Color": orderData.eyeColorId.replace('_', ' '),
                                "_Uploaded_Photo": orderData.imgbbLink,
                                "_Dedication Text": orderData.hasDedication ? orderData.dedicationMessage : "None",
                                "_Premium Paper": orderData.hasPremiumPaper ? "Yes" : "No",
                                "_Binding Type": orderData.bindingType,
                                "_Generated_Inside": orderData.resultInside,
                                "_Generated_Character": orderData.resultCharacter
                            }
                        });
                    }
                });
            }

            let baseIdNumber = dynamicBaseId ? Number(dynamicBaseId) : 12345678901234;
            let mainVariantIdToAdd = baseIdNumber; 

            let mainBookData = allStoreBooks.find(b => b.id === baseIdNumber || b.variants.some(v => v.id === baseIdNumber));

            if (mainBookData) {
                let targetBinding = orderData.bindingType.toLowerCase();
                
                let mainMatchedVariant = mainBookData.variants.find(v => 
                    v.title.toLowerCase().includes(targetBinding) && v.title.toLowerCase().includes("tier 1")
                );
                
                if (!mainMatchedVariant) {
                    mainMatchedVariant = mainBookData.variants.find(v => 
                        v.title.toLowerCase().includes(targetBinding)
                    );
                }

                if (mainMatchedVariant) {
                    mainVariantIdToAdd = mainMatchedVariant.id;
                }
            } else {
                console.warn("Main product not found in entire store catalog. Falling back to URL ID.");
            }

            itemsToAdd.push({
                id: mainVariantIdToAdd, 
                quantity: 1,
                properties: {
                    "_Child's Name": orderData.childName,
                    "_Gender": orderData.gender,
                    "_Eye Color": orderData.eyeColorId.replace('_', ' '),
                    "_Dedication Text": orderData.hasDedication ? orderData.dedicationMessage : "None",
                    "_Premium Paper": orderData.hasPremiumPaper ? "Yes" : "No",   
                    "_Binding Type": orderData.bindingType,
                    "_Generated_Inside": orderData.resultInside,
                    "_Generated_Character": orderData.resultCharacter,
                    "_Uploaded_Photo": orderData.imgbbLink
                }
            });

            let brokenItem = itemsToAdd.find(item => !item.id || isNaN(item.id));
            if (brokenItem) {
                alert("SYSTEMFEHLER: Eine der Variant-IDs fehlt oder ist ungültig! Bitte im Code überprüfen.");
                console.error("Broken Item Data:", brokenItem);
                finalBtn.innerText = "In den Warenkorb";
                finalBtn.style.opacity = "1";
                finalBtn.disabled = false;
                return; 
            }

            setTimeout(() => {
                window.location.href = '/collections/all?cart=open';
            }, 1200);

            fetch(window.Shopify.routes.root + 'cart/add.js?funnel_bypass=true', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: itemsToAdd })
            })
            .then(async (response) => {
                if (!response.ok) {
                    const errorData = await response.json();
                    throw new Error(errorData.description || "Invalid Variant ID sent to cart.");
                }
                return response.json();
            })
            .then(cart => {
                let numExtraBooks = orderData.additionalBooks ? orderData.additionalBooks.length : 0;
                let discountCode = "";
                
                if (numExtraBooks === 1) {
                    discountCode = "BUECHER2"; 
                } else if (numExtraBooks === 2) {
                    discountCode = "BUECHER3"; 
                } else if (numExtraBooks === 3) {
                    discountCode = "BUECHER4"; 
                } else if (numExtraBooks === 4) {
                    discountCode = "BUECHER5"; 
                } else if (numExtraBooks >= 5) {
                    discountCode = "BUECHER6"; 
                }

                if (discountCode) {
                    fetch(`/discount/${discountCode}`)
                    .then(() => {
                        window.location.href = '/collections/all?cart=open'; 
                    })
                    .catch(err => {
                        window.location.href = '/collections/all?cart=open';
                    });
                } else {
                    window.location.href = '/collections/all?cart=open'; 
                }
            })
            .catch(error => {
                finalBtn.innerText = "In den Warenkorb";
                finalBtn.style.opacity = "1";
                finalBtn.disabled = false;
                alert("Warenkorb-Fehler: " + error.message);
            });
        });
    }
    renderPhase1();
});